import { getFdaDisplayName } from "@capone/common";

export const getDisruptionProtectionText = (
  isFreeFdaEnabled: boolean,
  productVariant?: string
) => getFdaDisplayName({ isFreeFdaEnabled, productVariant });
// export const MISSED_CONNECTION_GUARANTEE = "Missed connection guarantee";
/** @see https://hopper-jira.atlassian.net/browse/COTA-1093 */
export const MISSED_CONNECTION_REBOOKING = "Missed connection rebooking";
export const CHOOSE_DEPARTURE_TEXT = "Departure";
export const CHOOSE_OUTBOUND_TEXT = "Outbound";
export const CHOOSE_RETURN_TEXT = "Return";
export const REVIEW_ITINERARY_TEXT = "Review itinerary";
export const CUSTOMIZE_TEXT = "Customize";
export const BOOK_TEXT = "Book";
export const BACK_TO_FLIGHT_RESULTS = "Back to Flight Results";

export const CHFAR_MISSION_CONTROL_TEXT = "Change your flight";
export const CHFAR_CHOOSE_NEW_FLIGHTS_TEXT = "Choose new flights";
export const CHFAR_CHOOSE_NEW_FLIGHT_TEXT = "Choose new flight";
